import type { ActionPayload, ActionValueMap, ChatStatus } from '../common/@types'
import { WIDGET_URL } from '../constants/environment'

type OutgoingActionPayload = ActionPayload<
  'SET_AUTH_TOKEN' | 'SET_DISPLAY_STATUS' | 'SET_ECOMMERCE_REFERER' | 'SET_WIDGET'
>
type IncomingActionPayload = ActionPayload<'SET_CHAT_STATUS' | 'SET_LOADED'>

class IframeMessage {
  private iframe: HTMLIFrameElement
  private loaded = false
  private queue: OutgoingActionPayload[] = []
  private setChatStatusCallback?: (value: ChatStatus) => void

  constructor(iframe: HTMLIFrameElement) {
    this.iframe = iframe

    window.addEventListener('message', (event: MessageEvent<IncomingActionPayload>) => {
      if (event.origin !== WIDGET_URL) return

      if (event.data.action === 'SET_LOADED') {
        this.loaded = event.data.value
        if (this.loaded) {
          this.flushQueue()
        }
      }

      if (event.data.action === 'SET_CHAT_STATUS') {
        this.setChatStatusCallback?.(event.data.value)
      }
    })
  }

  private flushQueue() {
    for (const payload of this.queue) {
      this.post(payload)
    }
    this.queue = []
  }

  private post(payload: OutgoingActionPayload) {
    this.iframe.contentWindow?.postMessage(payload, WIDGET_URL)
  }

  private enqueue(payload: OutgoingActionPayload) {
    if (!this.loaded) {
      this.queue.push(payload)
    } else {
      this.post(payload)
    }
  }

  public postAuthToken(value: ActionValueMap['SET_AUTH_TOKEN']) {
    this.enqueue({ action: 'SET_AUTH_TOKEN', value })
  }

  public postEcommerceReferer(value: ActionValueMap['SET_ECOMMERCE_REFERER']) {
    this.enqueue({ action: 'SET_ECOMMERCE_REFERER', value })
  }

  public postDisplayStatus(value: ActionValueMap['SET_DISPLAY_STATUS']) {
    this.enqueue({ action: 'SET_DISPLAY_STATUS', value })
  }

  public postWidget(value: ActionValueMap['SET_WIDGET']) {
    this.enqueue({ action: 'SET_WIDGET', value })
  }

  public onSetChatStatus(callback: (value: ChatStatus) => void) {
    this.setChatStatusCallback = callback
  }
}

export default IframeMessage
